// let ID = null;

export default class Analytics {
    // eslint-disable-next-line no-unused-vars
    static init(id) {
        // if (!ID) {
        //     ID = id;
        //     window.ga('create', ID, 'auto');
        // }
    }

    // eslint-disable-next-line no-unused-vars
    static pageView(path, title) {
        // window.ga('send', 'pageview', path, { title });
    }

    // eslint-disable-next-line no-unused-vars
    static sendEvent(action, category = 'Common') {
        // window.ga('send', 'event', category, action);
    }
}
